export const parseGqlError = (acc: {}, { message }: { message: string }) => {
  try {
    const parse = JSON.parse(message)
    acc = { ...acc, ...parse }
  } catch (error) {
    console.error('parseGqlError: ', error)
  }
  return acc
}
